import React from 'react';
import { Typography, Container, CssBaseline } from '@material-ui/core';
import BuildInfo from './helper/BuildInfo';
import SubjectConfig from './helper/SubjectConfig';



class AboutApp extends React.Component {
    render() {
        return (<Container>
            <CssBaseline />
            <br />
            <Typography variant='body1' color='primary' >{BuildInfo.appName}</Typography>
            <Typography variant='body2'  >версия: {BuildInfo.versionName} сборка: {BuildInfo.build}</Typography>
            <Typography variant='body2'  >Конфигурация от: {SubjectConfig.getLocal().generated} </Typography>
            <br />
            <Typography variant='body2' >
                Приложение для осуществления административно-производственного контроля.
                </Typography>

            <Typography variant='body2'  >
                Данное приложение развивается на базе Далматовского ЛПУМГ с февраля 2018 года.
                </Typography>
            <br />
            <Typography variant='body1' color='primary' >Разработчик</Typography>
            <Typography variant='body2'  >
                Васильченко Виталий Юрьевич - WasiliySoft © 2019-2020
                <br />
                email: <a href='mailto:wasiliysoft@gmail.com'>wasiliysoft@gmail.com</a>
            </Typography>
            <br />
            <Typography variant='body1' color='primary' >
                Библиотеки сторонних разработчиков
                </Typography>
            <Typography variant='body2' >
                Zxing-js - <a href='https://github.com/zxing-js/library'>https://github.com/zxing-js/library</a>
            </Typography>
        </Container>
        );
    }
}

export default AboutApp;
